export const getWorkSpaceIDFromCRN = (crn: string) => {
  if (!crn) return '';
  const regex = /workspace:([^/]+)/;
  const match = regex.exec(crn);

  return match?.[1] ?? '';
};
